if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterDOMLoaded);
} else {
    afterDOMLoaded();
}

function afterDOMLoaded() {
    
    try { setTimeout(mobileNavigationButtons, 500); } catch (err) { console.error('error in custom.js mobileNavigationButtons, err: ', err); }

    if(window.location.href.includes('swym-wishlist')) {
        try { setTimeout(wishListPage, 3000);  } catch(err) {console.error('error in custom.js wishListPage function, err: ', err); }
    }
    if(window.location.href.includes('swym-share-wishlist')) {
        try { setTimeout(sharedWishlist, 3000);  } catch(err) {console.error('error in custom.js wishListPage function, err: ', err); }
    }
    
    if (document.body.classList.contains('template-product')) {
    try { moveElementBasedOnWidth();} catch (err) {console.error('error in custom.js, moveElementBasedOnWidth function. err:', err);}
    try { stickyATCADA();} catch (err) {console.error('error in custom.js, stickyATCADA function. err:', err);}
    }

    if (document.body.classList.contains('template-cart')) {
        try { setTimeout(cartCheckbox, 1000);} catch (err) {console.error('error in custom.js, cartCheckbox function. err:', err);}
     }
    
     if (document.body.classList.contains('template-customers-account')) {
        try { setTimeout(warrantyCredits, 5000);} catch (err) {console.error('error in custom.js, warrantyCredits function. err:', err);}
     }

     if(window.location.href.includes('/a/faq') || window.location.href.includes('/pages/size-charts')) {
        try { setTimeout(initAccessibleFaqAccordion, 5000);} catch (err) {console.error('error in custom.js, initAccessibleFaqAccordion function. err:', err);}

     }
     
}


function moveElementBasedOnWidth() {
  // Get the element and the target container
  const headerElement = document.querySelector(".product-single__meta .product-block--header");
  const widthCopy = document.querySelector(".width-copy");
  const yotpoEmbed = document.querySelector("div[id*='yotpo_product_reviews_star_rating']");

  // Check if required elements exist before proceeding
  if (!headerElement) return;
  
  if (widthCopy) {
    headerElement.appendChild(widthCopy);
  }
  if (yotpoEmbed) {
    headerElement.appendChild(yotpoEmbed);
  }
  
  const targetContainer = document.querySelector(".page-content--product .page-width .grid");
  // Fixed selector: medium-up--two-fifths should be a class on grid__item, not a descendant
  const originalContainer = document.querySelector(".grid__item.medium-up--two-fifths .product-single__meta") || 
                            document.querySelector(".product-single__meta");

  // Check if containers exist before proceeding
  if (!targetContainer || !originalContainer) return;

  
 // Function to move the element based on the width
  function checkWidthAndMove() {
    // Ensure elements still exist before moving
    if (!headerElement || !targetContainer || !originalContainer) return;
    
    if (window.innerWidth < 768) {
      // Move the element to the target container as the first child
      if (targetContainer && headerElement.parentNode !== targetContainer) {
        targetContainer.insertBefore(headerElement, targetContainer.firstChild);
      }
    } else {
      // Otherwise, append the element back to its original parent container
      if (originalContainer && headerElement.parentNode !== originalContainer) {
        originalContainer.insertBefore(headerElement, originalContainer.firstChild);
      }
    }
  }

  // Run the check on page load
  checkWidthAndMove();

   // Listen to window resize events
  window.addEventListener('resize', checkWidthAndMove);
}

// Add Aria-Labels to Sticky ATC Icons
function stickyATCADA() {
    const variantDropdownSVGs = document.querySelectorAll('div[data-essential-cart-element="variant-select"] div[data-essential-cart-element="icon"] svg');
    if(variantDropdownSVGs) {
        variantDropdownSVGs.forEach(variantDropdownSVG => {
            variantDropdownSVG.setAttribute("aria-label", "Variant Selection Dropdown")
        })
        
    }

    const quantityLessButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:first-of-type');
    const quantityLessSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"])');
    if (quantityLessButtons && quantityLessSVGs) {
        quantityLessButtons.forEach(quantityLessButton => {
            quantityLessButton.setAttribute("aria-label", "Reduce item quantity by one");
        })
        quantityLessSVGs.forEach(quantityLessSVG => {
            quantityLessSVG.setAttribute("aria-label", "Reduce item quantity by one");
        })
       
    }

    const quantityMoreButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:last-of-type');
    const quantityMoreSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"])');
    if (quantityMoreButtons && quantityMoreSVGs) {
        quantityMoreButtons.forEach(quantityMoreButton => {
            quantityMoreButton.setAttribute("aria-label", "Increase item quantity by one"); 
        })
        quantityMoreSVGs.forEach(quantityMoreSVG => {
            quantityMoreSVG.setAttribute("aria-label", "Increase item quantity by one");
        })
        
        
    }
}

/**
 * Change Tab Index Attribute of Mobile Navigation Dropdowns
 */
function mobileNavigationButtons() {
    const dropdownButtons = document.querySelectorAll('div.mobile-nav__toggle button.collapsible-trigger');
    if (dropdownButtons) {
        dropdownButtons.forEach(dropdownButton => {
        dropdownButton.setAttribute('tabindex', '0');
        })
    }
}

// WishList Page Customizations
function wishListPage() {
    const loginBlock = document.querySelector('div.swym-storefront-layout-login-user-container');
    if (loginBlock) {
        const parentLoginBlock = loginBlock.parentNode;
        const wishListWrapper = document.querySelector('.swym-storefront-layout-tab-container');
        const wishListBody = document.querySelector('div.swym-storefront-layout-body');

        wishListWrapper.insertBefore(parentLoginBlock, wishListBody);

    }
   

    // remove '+' from arrow 
    const ATCButtons = document.querySelectorAll('button.swym-storefront-layout-grid-item-add-to-cart-button:not(button[disabled])');
    if(ATCButtons) {
    ATCButtons.forEach(ATCButton => {
        ATCButton.innerHTML = 'Add to Cart';
        })
    }

    const shareSVGButton = document.querySelector('button.swym-single-share-wishlist-btn');
    if (shareSVGButton) {
        const shareCopy = document.createElement('span');
        shareCopy.innerHTML = 'Share Wishlist';
        shareCopy.setAttribute('class', 'share-copy');
        shareCopy.style.textDecoration = 'underline';
        shareCopy.style.fontWeight = '600';

        const shareSVG = document.querySelector('button.swym-single-share-wishlist-btn svg');
        shareSVG.style.display = "none";
        shareSVGButton.insertBefore(shareCopy, shareSVG);
    }

    const loginHeading = document.querySelector('.swym-storefront-layout-login-heading');
    const loginCopy = document.querySelector('.swym-storefront-layout-login-description');
    if (loginHeading && loginCopy) {
        loginHeading.innerHTML = 'Don\'t lose your list.';
        loginCopy.innerHTML = 'Login to save your favorites and access them whenever.'
    }

} 

// Shared Wishlist Page Customizations
function sharedWishlist() {
    const wishlistTitle = document.querySelector('.swym-wishlist-main-title.swym-heading');
    if (wishlistTitle) {
        wishlistTitle.remove();
        const newTitle = document.createElement('h1');
        newTitle.setAttribute('class', 'swym-wishlist-main-title');
        newTitle.innerHTML = "Shared Wishlist";
        const parentWrapper = document.querySelector('.swym-wishlist-detail-header');
        const siblingElement = document.querySelector('.swym-wishlist-name-container');
        parentWrapper.insertBefore(newTitle, siblingElement);
    }
}

/** 
 * Add Aria-Label to T&C Checkbox in Cart
 */
function cartCheckbox() {
    const termsCheckbox = document.querySelector('span.rale-box svg');
    if(termsCheckbox){
        termsCheckbox.setAttribute('aria-label', 'Accept terms of purchase and website use');
    }
}

/**
 * Check if Warranty Credit Table is Empty and hide title if it is
 * 
 */

function warrantyCredits() {
    var warrantyTable = document.querySelector(".warranty div");
    console.log(warrantyTable);
    if (warrantyTable.childElementCount === 0) {
        var warrantyHeader = document.querySelector(".warranty h2");
        warrantyHeader.style.display = "none";
    }
}

/**
 * Wide Open Socks - FAQ accordion accessibility enhancement
 * Makes the FAQ Plus accordion WCAG 2.1 AA compliant for keyboard users.
 *
 * What it does:
 *   - Converts each label-based toggle into a real <button> (2.1.1 Keyboard,
 *     4.1.2 Name, Role, Value) so it's reachable via Tab and operable with
 *     Enter / Space.
 *   - Adds aria-expanded, aria-controls, and a labelled region so screen
 *     readers announce state and the panel relationship (1.3.1 Info &
 *     Relationships).
 *   - Preserves the app's checkbox-driven CSS, so existing open/close styling
 *     and animations keep working - the button just drives the checkbox.
 *   - Adds Up / Down / Home / End arrow navigation between headers
 *     (ARIA Authoring Practices accordion pattern).
 */
function initAccessibleFaqAccordion(root = document) {
  const items = root.querySelectorAll('.faqPlusAppFaq');

  items.forEach((item, index) => {
    if (item.dataset.a11yEnhanced === 'true') return;

    const checkbox = item.querySelector('input.faqPlusAppToggle');
    const label = item.querySelector('label.faqPlusAppTitle');
    const panel = item.querySelector('.faqPlusAppContent');
    if (!label || !panel) return;

    // Stable IDs for the ARIA relationships.
    const baseId = (checkbox && checkbox.id) || item.id || `faq-item-${index}`;
    const buttonId = `${baseId}-button`;
    if (!panel.id) panel.id = `${baseId}-panel`;

    // Build a real button that replaces the clickable label.
    const button = document.createElement('button');
    button.type = 'button';
    button.id = buttonId;
    button.className = label.className;           // keep theme styling hooks
    if (label.hasAttribute('itemprop')) {          // keep schema.org "name"
      button.setAttribute('itemprop', label.getAttribute('itemprop'));
    }
    while (label.firstChild) button.appendChild(label.firstChild);

    const expanded = !!(checkbox && checkbox.checked);
    button.setAttribute('aria-expanded', String(expanded));
    button.setAttribute('aria-controls', panel.id);

    // Swap label -> button, keeping DOM order (input, button, panel) so the
    // app's sibling-combinator CSS still matches.
    label.replaceWith(button);

    // The checkbox stays (it drives the CSS) but is hidden from AT and Tab.
    if (checkbox) {
      checkbox.setAttribute('aria-hidden', 'true');
      checkbox.tabIndex = -1;
    }

    // Point the panel back at its control.
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', buttonId);

    // Toggle on activation (Enter / Space fire click natively on buttons).
    button.addEventListener('click', () => {
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(willOpen));
      if (checkbox) {
        checkbox.checked = willOpen;             // triggers the existing :checked CSS
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Roving arrow-key navigation between headers.
    button.addEventListener('keydown', (event) => {
      const headers = Array.from(
        root.querySelectorAll('.faqPlusAppFaq > button.faqPlusAppTitle')
      );
      const i = headers.indexOf(event.currentTarget);
      let next;
      switch (event.key) {
        case 'ArrowDown': next = headers[i + 1]; break;
        case 'ArrowUp':   next = headers[i - 1]; break;
        case 'Home':      next = headers[0]; break;
        case 'End':       next = headers[headers.length - 1]; break;
        default: return;
      }
      if (next) {
        event.preventDefault();
        next.focus();
      }
    });

    item.dataset.a11yEnhanced = 'true';
  });
}
